import React from 'react';

export default function TeamCard({ intro, text }) {
    return <div className="team-card">
        <h4 className="team-card__intro">{intro}</h4>
        <p className="team-card__text lead">{text}</p>
    </div>
}